import { render, staticRenderFns } from "./vistaexamenalumno.vue?vue&type=template&id=ea133aec&scoped=true&"
import script from "./vistaexamenalumno.vue?vue&type=script&lang=js&"
export * from "./vistaexamenalumno.vue?vue&type=script&lang=js&"
import style0 from "./vistaexamenalumno.vue?vue&type=style&index=0&id=ea133aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea133aec",
  null
  
)

export default component.exports